///
/// EarthBrowser
///
/// Migration v13 to v14: Add persisted window states
///
/// Created by Matt Giger on December 20, 2025
/// Copyright (c) 2025 Geodata Labs
///

interface StateV13 {
	userInterface?: Record<string, unknown>
}

/**
 * Migration from version 13 to 14: Add persisted window states for restoration
 * - Adds persistedWindowStates field to userInterface slice (empty object)
 * - Enables windows to be restored on app launch with their previous state
 * - Stores window position, size, maximized/minimized state, and visibility
 */
export function migrateV13toV14(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV13

	// Return new state with persistedWindowStates added
	return {
		...s,
		userInterface: {
			...s.userInterface,
			persistedWindowStates: {}
		}
	}
}
